import { AnyAction, Dispatch } from 'redux'
import { AxiosError, AxiosResponse } from 'axios'
import { camelize } from 'casing'
import {
  errorLogger,
  getErrorMessages,
  LoadingTypes,
  startLoading,
  stopLoading,
  updateAppAlert,
} from '@labrav/common'

import {
  getMetricsData,
  getMetricsProductData,
} from '../../api/marketplace/index'
import { RequestFailureMessage } from '../../common/utils/messagesContants'
import type { AppDispatch, RootState } from '../../store/types'
import {
  StorefrontMetricsActionTypes,
  type DateRange,
  type InteractionsData,
  type MetricsData,
} from './types'
import { decodeBase64 } from './utils/decodeBase64'
import { getMonthAbbreviation } from './utils/getMonthAbbreviation'

export { StorefrontMetricsActionTypes }
export { decodeBase64 } from './utils/decodeBase64'

export const getStorefrontMetricsData =
  (domain?: string, selectedProduct?: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.METRICS_LOADING))
    // await dispatch(clearStorefrontMetricsData())
    try {
      const partnerId = getState().AccountData.user.partnerData?.partnerId || ''
      const { dateRange } = getState().storefrontMetricsData
      const finalStartDate = dateRange.startDate
      const finalEndDate = dateRange.endDate

      const products = await getMetricsProductData({ partnerId })
      // const response = camelize(storefrontMetricsMock)
      const { data } = await getMetricsData({
        partnerId,
        finalStartDate,
        finalEndDate,
        domain,
        selectedProduct,
      })
      // const response = camelize(data)
      const response = camelize(data)
      const transformedMetricsData: MetricsData = {
        ...response,
        domainNames: ['All domains', ...response?.domainNames],
        graphData:
          response?.graphData?.map((item: InteractionsData) => ({
            ...item,
            data:
              item?.data?.map(({ date, value }) => ({
                x: getMonthAbbreviation(date),
                y: value,
              })) || [],
          })) || [],
        trafficSource: {
          ...response.trafficSource,
          otherTrafficSource:
            response?.trafficSource?.otherTrafficSource?.map((item: any) => ({
              ...item,
              ref: decodeBase64(item?.ref),
            })) || [],
          top3:
            response?.trafficSource?.top3?.map((item: any) => ({
              ...item,
              ref: decodeBase64(item?.ref),
            })) || [],
        },
        productOptions: [
          { label: 'All listings', value: 'allListings' },
          ...(
            (products?.data as { product_id: string; name: string }[]) || []
          ).map(
            ({ product_id, name }: { product_id: string; name: string }) => ({
              label: name,
              value: product_id,
            })
          ),
        ],
      }
      await dispatch(setStorefrontMetricsData(transformedMetricsData))
      await dispatch(
        updateAppAlert({
          message: '',
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.METRICS_LOADING))
    }
  }
export const setStorefrontMetricsData = (metricsData: MetricsData) => {
  return {
    type: StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_DATA,
    payload: metricsData,
  }
}
export const setStorefrontMetricDomain = (domain: string) => {
  return {
    type: StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_DOMAIN,
    payload: domain,
  }
}
export const setStorefrontMetricProduct = (selectedProduct: string) => {
  return {
    type: StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_PRODUCT,
    payload: selectedProduct,
  }
}
export const clearStorefrontMetricsData = () =>
  ({
    type: StorefrontMetricsActionTypes.CLEAR_STOREFRONT_METRICS_DATA,
  }) as unknown as AnyAction
export const updateMetricDateRange =
  (dates: DateRange) => async (dispatch: AppDispatch) => {
    const { startDate, endDate } = dates
    await dispatch(setDateRange({ startDate, endDate }))
  }
export const setDateRange = (dates: DateRange) => ({
  type: StorefrontMetricsActionTypes.SET_DATE_RANGE,
  payload: dates,
})
